import ChevronIcon from "assets/icons/ChevronIcon";
import PercentIcon from "assets/icons/PercentIcon";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import {useEffect, useState} from "react";

interface ConditionalTextInputProps {
    def?: FD;
    onChange?: (fd: any) => void;
}

interface FD {
    value?: string | number;
    first?: "inc" | "dec";
    second?: "percent" | "currency";
}

export default function ConditionalTextInput(props: ConditionalTextInputProps) {
    const {def, onChange} = props;
    const [fd, setFd] = useState<FD>(
        def || {
            first: "inc",
            second: "percent",
        }
    );

    useEffect(() => {
        onChange && onChange(fd);
    }, [fd]);

    return (
        <div
            style={{
                border: "1px solid #C2D0E3",
                borderRadius: 6,
                minHeight: 40,
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 4,
                gap: 4,
            }}
        >
            <div style={{display: "flex", alignItems: "center", gap: 16, width: "100%"}}>
                <div
                    style={{display: "flex", alignItems: "center", cursor: "pointer", gap: 12}}
                    onClick={() => setFd((x) => ({...x, first: x.first === "inc" ? "dec" : "inc"}))}
                >
                    <div></div>
                    <span style={{fontSize: 14, fontWeight: 400, color: "#33383D", width: 36}}>
            {fd.first === "inc" ? "افزایش" : "کاهش"}
          </span>
                    <div className="flex flex-col relative">
                        <ChevronIcon
                            color={fd.first === "inc" ? "#1062D0" : undefined}
                            rotate="top"
                            style={{marginBottom: -3}}
                        />
                        <ChevronIcon color={fd.first === "dec" ? "#1062D0" : undefined} style={{marginTop: -3}}/>
                    </div>
                </div>
                <div style={{width: 1, height: 20, backgroundColor: "#AEAEAE"}}></div>
                <BasicTextInput
                    type="price"
                    fullWidth
                    style={{
                        border: 0,
                        width: "100%",
                    }}
                    val={fd.value}
                    onChange={(val) => setFd((x) => ({...x, value: val}))}
                />
            </div>
            <div>
                <div
                    style={{
                        backgroundColor: "#EBEFF5",
                        width: 32,
                        height: 32,
                        borderRadius: 3,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        color: "#1062D0",
                    }}
                    onClick={() => setFd((x) => ({...x, second: x.second === "percent" ? "currency" : "percent"}))}
                >
                    {fd.second === "percent" ? <PercentIcon style={{transform: "scale(0.7)"}}/> : "ريال"}
                </div>
            </div>
        </div>
    );
}
